import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommunitySearch from "./Community_UI/CommunitySearch";
import { get } from "../../utility/fetchWeb";
import Spinner from "../Spinner";
import DoctorList from "./DoctorList"; // Import the new component
import HospitalList from "./HospitalList";

const Caregivers = () => {
    // Tab state: joined, created, friends, or discover
    const [activeTab, setActiveTab] = useState("discover");
    // Search state (shared across views for demo purposes)
    const [searchQuery, setSearchQuery] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [communityList, setCommunityList] = useState([]);
    const [doctorList, setDoctorList] = useState([]);

    const [groupList, setGroupList] = useState([]);
    const [groupLoading, setGroupLoading] = useState(false);
    const navigate = useNavigate();

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getCommunity = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/HealthCareProvider/list/1/10`);
            if (response) {
                console.log(response?.resultList)
                setCommunityList(response?.resultList);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    const getDoctors = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Doctors/list/1/10`);
            if (response) {
                console.log(response?.resultList)
                setCommunityList(response?.resultList);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    const searchCommunity = async (searchQuery) => {
        setGroupLoading(true);
        try {
            const response = await get(`/HealthCareProvider/HealthCareProvider/${searchQuery}/1/10`);
            if (response) {
                setCommunityList(response?.resultList);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    const searchDoctors = async () => {
        setGroupLoading(true);
        try {
            const response = await get(`/Doctors/list/1/10`);
            if (response) {
                console.log(response?.resultList)
                setCommunityList(response?.resultList);
                setGroupLoading(false);
            } else {
                setGroupLoading(false);
            }
        } catch (error) {
            setGroupLoading(false);
            console.error("Error fetching community data:", error);
        }
    };

    useEffect(() => {
        if (searchQuery) {
            searchCommunity(searchQuery);
        } else {
            getCommunity();
        }
    }, [searchQuery]);

    useEffect(() => {
        if (activeTab === "doctors") {
            getDoctors(); // Fetch doctors only when the active tab is "doctors"
        } else if (activeTab === "discover") {
            getCommunity(); // Fetch facilities when the active tab is "discover"
        }
    }, [activeTab]);

    // Replace groupsData with dynamic filtering logic
    const filterGroups = (groupType) => {
        if (groupType === "created") {
            // Filter communities created by the current user (assuming user ID is 0 for now)
            return communityList.filter((community) => community.createdBy === Number(sessionStorage.getItem("userId")));
        } else if (groupType === "joined") {
            // Filter communities where the current user is a member (assuming user ID is 0 for now)
            return communityList.filter((community) =>
                community.communityMembers.some((member) => member.patient.id === Number(sessionStorage.getItem("userId")))
            );
        }
        return [];
    };

    // Update renderGroupsGrid to use the updated filterGroups logic
    const renderGroupsGrid = (groupType, headerText) => {
        const filteredGroups = filterGroups(groupType);
        return (
            <>
                <div className="flex space-between m-b-40 m-t-20">
                    <div>
                        <h3 className="group-name">{headerText}</h3>
                        <p className="community-description">
                            {filteredGroups.length} groups
                        </p>
                    </div>
                    <div className="float-right m-l-40">
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search for Groups"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                            <span className="filter-icon">🔍</span>
                        </div>
                    </div>
                </div>
                <div className="groups-grid">
                    {filteredGroups.map((group) => (
                        <div className="group-card" key={group.id}>
                            <div className="group-info">
                                <div className="flex gap-10">
                                    <img
                                        src={group.pictureUrl || "/user-avater.png"}
                                        alt="Group"
                                        className="profile-pic"
                                    />
                                    <span>
                                        <h3 className="group-name">{group.name}</h3>
                                        <p className="group-details">{group.description}</p>
                                    </span>
                                </div>
                                <div className="flex gap-10 space-between">
                                    <button
                                        className="submit-btn"
                                        onClick={() => navigate("/group")}
                                    >
                                        View Group
                                    </button>
                                    <button className="save-drafts col-2">...</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>
        );
    };

    return (
        <div className="community-container">
            <div className="flex space-between">
                <div className="profile-section">
                    <img
                        src="/user-avater.png"
                        alt="User Profile"
                        className="profile-img"
                    />
                    <div>
                        <h2>Good morning!</h2>
                        <p>{sessionStorage.getItem('userName') || ''}</p>
                    </div>
                </div>
                <div className="w-60">
                    <div className="search-container float-right w-40">
                        <input
                            type="text"
                            placeholder="Search for Groups"
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <span className="filter-icon">🔍</span>
                    </div>
                </div>
            </div>

            <div className="flex space-between m-t-20 m-b-10">
                <h2 className="section-title">Care Givers</h2>
                {/* <div className="w-30">
                    <button
                        className="submit-btn"
                        onClick={() => navigate("/create-group")}
                    >
                        + Create Group
                    </button>
                </div> */}
            </div>
            <p className="community-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, nulla a
                accumsan at morbi bibendum tortor id a. Nullam amet, ultricies orci
                ultricies odio condimentum.
            </p>

            {/* Tabs */}
            <div className="com-tabs">
                {/* <span
                    className={`com-tab ${activeTab === "joined" ? "active" : ""}`}
                    onClick={() => setActiveTab("joined")}
                >
                    Groups Joined
                </span>
                <span
                    className={`com-tab ${activeTab === "created" ? "active" : ""}`}
                    onClick={() => setActiveTab("created")}
                >
                    Groups Created
                </span>*/}
                <span
                    className={`com-tab ${activeTab === "doctors" ? "active" : ""}`}
                    onClick={() => setActiveTab("doctors")}
                >
                    Profiles
                </span>
                <span
                    className={`com-tab ${activeTab === "discover" ? "active" : ""}`}
                    onClick={() => setActiveTab("discover")}
                >
                    Facilities
                </span>
            </div>

            {/* Conditional rendering based on the active tab */}
            {activeTab === "joined" && renderGroupsGrid("joined", "All Groups You've Joined")}
            {activeTab === "created" && renderGroupsGrid("created", "All Groups You've Created")}
            {activeTab === "friends" && (
                <div className="coming-soon">
                    <h3>Friends</h3>
                    <p>Friends functionality coming soon.</p>
                </div>
            )}
            
            {activeTab === "discover" &&
                <div>
                    {groupLoading ?
                        <div className="spinner"><Spinner /></div>
                        :
                        <HospitalList hospitalList={communityList} loading={groupLoading} />
                    }
                </div>
            }
            {activeTab === "doctors" && (
                <DoctorList doctorList={communityList} loading={groupLoading} />
            )}
        </div>
    );
};

export default Caregivers
